export default "__VITE_ASSET__BpDJL5_o__"